import dumbell from "../images/dumbell.png";
import { Theme } from "../style/Theme";

export const genderOptions = [
  {
    id: 0,
    name: "Male",
    label: "♂ Male",
  },
  {
    id: 1,
    name: "Female",
    label: "♀ Female",
  },
];

export const LEVELOPTIONS = [
  {
    id: 0,
    name: "Rookie",
    color: Theme.palette.up,
    desc: "Just starting out - welcome!",
    icon: "🌱",
  },
  {
    id: 1,
    name: "Scaled",
    color: Theme.palette.blue,
    desc: "Comfortable with basic movements",
    icon: "📈",
  },
  {
    id: 2,
    name: "Intermediate",
    color: Theme.palette.gold,
    desc: "Solid foundation, growing strength",
    icon: "⚡",
  },
  {
    id: 3,
    name: "Rx",
    color: Theme.palette.orange,
    desc: "Competitive & advanced athlete",
    icon: "🔥",
  },
];

export const WORKOUT_TYPES_DATA = [
  {
    id: 1,
    icon: "⚡",
    name: "For Time",
    description: "Beat the clock",
    color: Theme.palette.gold,
  },
  {
    id: 2,
    icon: "♾",
    name: "AMRAP",
    description: "Max reps",
    color: Theme.palette.up,
  },
  {
    id: 3,
    icon: "⏱",
    name: "EMOM",
    description: "On the minute",
    color: Theme.palette.blue,
  },
  {
    id: 4,
    icon: "🔄",
    name: "Intervals",
    description: "Work & rest",
    color: Theme.palette.orange,
  },
  {
    id: 5,
    icon: "📶",
    name: "Ladder",
    description: "Max reps",
    color: Theme.palette.purple,
  },
];

export const EXERCISE_CATEGORIES_DATA = [
  {
    id: 1,
    icon: "🎲",
  },
  {
    id: 2,
    icon: "🤸",
  },
  {
    id: 3,
    icon: "🏃",
  },
  {
    id: 4,
    icon: "🏋",
  },
  {
    id: 5,
    icon: <img src={dumbell} alt={"Dumbell Icon"} width={18} height={18} />,
  },
];
export const VisibilityStatuses = [
  {
    id: 0,
    name: "Private",
  },
  {
    id: 1,
    name: "Public",
  },
];

export const workoutActivityStatuses = [
  {
    id: 0,
    name: "No",
  },
  {
    id: 1,
    name: "Yes",
  },
];

export const workoutCapStatuses = [
  {
    id: 0,
    name: "After timecap",
  },
  {
    id: 1,
    name: "Before timecap",
  },
];

export const SCALING_REASONS = [
  {
    id: 1,
    icon: "🤝",
    title: "Inclusivity for All Levels",
    text: "Scaling ensures that individuals of all fitness backgrounds, from beginners to advanced athletes, can participate in workouts safely and effectively. It allows modifications in load, movement complexity and intensity to suit different capabilities.",
  },
  {
    id: 2,
    icon: "🛡️",
    title: "Injury Prevention",
    text: "Performing movements beyond one’s strength, flexibility or skill level can lead to injuries. Scaling helps athletes develop proper mechanics before adding intensity, reducing the risk of strains, sprains and overuse injuries.",
  },
  {
    id: 3,
    icon: "📈",
    title: "Progressive Development",
    text: "Functional fitness is built on the philosophy of constant improvement. Scaling helps athletes progressively build strength, endurance and skill while maintaining proper form. It allows for sustainable long-term progress rather than forcing premature advancements.",
  },
  {
    id: 4,
    icon: "🎨",
    title: "Adaptation to Individual Needs",
    text: "Athletes may face temporary limitations due to injuries, mobility restrictions or fatigue. Scaling ensures they can still complete workouts in a way that supports their recovery and growth rather than exacerbating their condition.",
  },
];

export const SCALING_BENEFITS = [
  {
    id: 1,
    icon: "🎯",
    title: "Maintains Workout Intensity",
    text: "Scaling adjusts difficulty while preserving the intended intensity of the workout. Whether reducing weights, modifying movements, or shortening repetitions, athletes still experience the metabolic and strength-building benefits.",
  },
  {
    id: 2,
    icon: "💪",
    title: "Builds Confidence and Motivation",
    text: "Completing a challenging yet achievable workout boosts confidence. Instead of feeling discouraged by an unattainable RX (prescribed) workout, athletes who scale properly feel empowered and motivated to progress.",
  },
  {
    id: 3,
    icon: "🏆",
    title: "Enhances Skill Development",
    text: "Scaling allows athletes to focus on technique rather than just completing the workout. Mastering fundamental movements before progressing to more complex exercises leads to greater efficiency and effectiveness in the long run.",
  },
  {
    id: 4,
    icon: "📈",
    title: "Encourages Consistency",
    text: "When workouts are scalable, athletes are more likely to remain consistent in their training. If every session is too difficult or painful, motivation can decline, whereas a well-scaled workout keeps training enjoyable and sustainable.",
  },
  {
    id: 5,
    icon: "🏆",
    title: "Promotes Longevity in Training",
    text: "Scaling ensures that functional fitness is not just for the short term but can be a lifelong pursuit. Avoiding unnecessary strain and injury means athletes can continue training well into older age while maintaining fitness and health.",
  },
];
